import React from 'react';
import {
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class Player extends React.Component {

  constructor(props) {
    super(props);
    // console.log('Player props:', props);
  }

  render() {
    const isExpandedFriend = /\+\d+$/.test(this.props.player._last_name || '');
    const isFriendSlot = this.props.flag === undefined || isExpandedFriend;
    const friendGender = isFriendSlot && this.props.player._friend_sex ?
        (this.props.player._friend_sex === 'M' ? ' + 🕺' : ' + 💃') : '';

    return(
        <div className="col-xs-4">
            <div
                className={"slots__item-place-user " + (this.props.player._is_current_user ? "slots__item-place-user--current" : "")}
                data-toggle="tooltip"
                data-placement="top"
                title={this.props.player._first_name + ' ' + this.props.player._last_name + friendGender} >

                {this.props.player._rating_level > 0 && (
                    <div className={`player-avatar-ring level-${this.props.player._rating_level}`}></div>
                )}
                <img className="slots__item-place-user-img img-responsive"
                     src={this.props.player._photo}
                     alt={this.props.player._first_name + ' ' + this.props.player._last_name + friendGender} />

            </div>
        </div>
    );
  }
}


export default Player;
